import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, thriweDiscoveryUrl } from '../../../../../Containers/Config/index.js';
import { Constant } from '../../../../../Containers/Helpers/constant.js';
import apiCall from '../../../apiCall';
import { GET_EVENTS_LIST, GET_EVENTS_LIST_ERROR, GET_EVENTS_LIST_SUCCESS } from './../../../actionType.js';

function* getListSurgeEvents({ payload }) {
  try {
    const response = yield call(apiCall, {
      url: `${thriweDiscoveryUrl}/v1/admin/list-events`,
      method: 'GET',
      headers: {
        Authorization: Constant?.CLIENT_TOKEN,
        ...customHeaders,
      },
      params: {
        ...payload?.urlParams,
      },
    });

    if (response.status === 200) {
      yield put({
        type: GET_EVENTS_LIST_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: GET_EVENTS_LIST_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: GET_EVENTS_LIST_ERROR, payload: error });
  }
}

export function* watchListSurgeEvents() {
  yield takeEvery(GET_EVENTS_LIST, getListSurgeEvents);
}

function* listSurgeEventsSaga() {
  yield all([fork(watchListSurgeEvents)]);
}

export default listSurgeEventsSaga;
